<template>
  <div class="privacy">
    <br />
    <br />
    <h1>
      <strong>{{ clientDetails.clientName }} </strong>Privacy Policy
    </h1>
    <p>
      This Privacy Policy describes how your personal information is collected,
      used, and shared when you visit or make a purchase from
      <strong>{{ clientDetails.clientWebsite }}</strong> (the “Site”).
    </p>
    <br />
    <h2>PERSONAL INFORMATION WE COLLECT</h2>
    <p>
      When you visit the Site, we automatically collect certain information
      about your device, including information about your web browser, IP
      address, time zone, and some of the cookies that are installed on your
      device. Additionally, as you browse the Site, we collect information about
      the individual web pages or products that you view, what websites or
      search terms referred you to the Site, and information about how you
      interact with the Site. We refer to this automatically-collected
      information as “Device Information.”
    </p>
    <br />
    <p>We collect Device Information using the following technologies:</p>
    <ul>
      <li>
        “Cookies” are data files that are placed on your device or computer and
        often include an anonymous unique identifier. For more information about
        cookies, and how to disable cookies, visit
        http://www.allaboutcookies.org.
      </li>
      <li>
        “Log files” track actions occurring on the Site, and collect data
        including your IP address, browser type, Internet service provider,
        referring/exit pages, and date/time stamps.
      </li>
      <li>
        “Web beacons,” “tags,” and “pixels” are electronic files used to record
        information about how you browse the Site.
      </li>
    </ul>
    <p>[[INSERT DESCRIPTIONS OF OTHER TYPES OF TRACKING TECHNOLOGIES USED]]</p>
    <br />
    <p>
      Additionally when you make a purchase or attempt to make a purchase
      through the Site, we collect certain information from you, including your
      name, billing address, shipping address, payment information (including
      credit card numbers [[INSERT ANY OTHER PAYMENT TYPES ACCEPTED]]), email
      address, and phone number. We refer to this information as “Order
      Information.”
    </p>
    <br />
    <p>
      [[INSERT ANY OTHER INFORMATION YOU COLLECT: OFFLINE DATA, PURCHASED
      MARKETING DATA/LISTS]]
    </p>
    <br />
    <p>
      When we talk about “Personal Information” in this Privacy Policy, we are
      talking both about Device Information and Order Information.
    </p>
    <br />
    <h2>HOW DO WE USE YOUR PERSONAL INFORMATION?</h2>
    <p>
      We use the Order Information that we collect generally to fulfill any
      orders placed through the Site (including processing your payment
      information, arranging for shipping, and providing you with invoices
      and/or order confirmations). Additionally, we use this Order Information
      to:
    </p>
    <ul>
      <li>Communicate with you;</li>
      <li>Screen our orders for potential risk or fraud; and</li>
      <li>
        When in line with the preferences you have shared with us, provide you
        with information or advertising relating to our products or services.
      </li>
      <li>[[INSERT OTHER USES OF ORDER INFORMATION]]</li>
    </ul>
    <br />
    <p>
      We use the Device Information that we collect to help us screen for
      potential risk and fraud (in particular, your IP address), and more
      generally to improve and optimize our Site (for example, by generating
      analytics about how our customers browse and interact with the Site, and
      to assess the success of our marketing and advertising campaigns).
    </p>
    <br />
    <p>
      [[INSERT OTHER USES OF DEVICE INFORMATION, INCLUDING:
      ADVERTISING/RETARGETING]]
    </p>
    <br />

    <h2>SHARING YOUR PERSONAL INFORMATION</h2>
    <p>
      We share your Personal Information with third parties to help us use your
      Personal Information, as described above. For example, we use Shopify to
      power our online store--you can read more about how Shopify uses your
      Personal Information here: https://www.shopify.com/legal/privacy. We also
      use Google Analytics to help us understand how our customers use the
      Site--you can read more about how Google uses your Personal Information
      here: https://www.google.com/intl/en/policies/privacy/. You can also
      opt-out of Google Analytics here:
      https://tools.google.com/dlpage/gaoptout.
    </p>
    <br />
    <p>
      Finally, we may also share your Personal Information to comply with
      applicable laws and regulations, to respond to a subpoena, search warrant
      or other lawful request for information we receive, or to otherwise
      protect our rights.
    </p>
    <br />
    <p>[[INCLUDE IF USING REMARKETING OR TARGETED ADVERTISING]]</p>
    <br />

    <h2>BEHAVIOURAL ADVERTISING</h2>
    <p>
      As described above, we use your Personal Information to provide you with
      targeted advertisements or marketing communications we believe may be of
      interest to you. For more information about how targeted advertising
      works, you can visit the Network Advertising Initiative’s (“NAI”)
      educational page at
      http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
    </p>
    <br />
    <p>You can opt out of targeted advertising by:</p>
    <ul>
      <li>
        FACEBOOK -
        <a
          class="link"
          href="https://www.facebook.com/settings/?tab=ads"
          target="_blank"
          >link</a
        >
      </li>
      <li>
        GOOGLE -
        <a
          class="link"
          href="https://www.google.com/settings/ads/anonymous"
          target="_blank"
          >link</a
        >
      </li>
      <li>
        BING -
        <a
          class="link"
          href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
          target="_blank"
          >link</a
        >
      </li>
      <li>INCLUDE OPT-OUT LINKS FROM WHICHEVER SERVICES BEING USED.</li>
    </ul>
    <br />
    <p>
      Additionally, you can opt out of some of these services by visiting the
      Digital Advertising Alliance’s opt-out portal at:
      http://optout.aboutads.info/.
    </p>
    <br />

    <h2>DO NOT TRACK</h2>
    <p>
      Please note that we do not alter our Site’s data collection and use
      practices when we see a Do Not Track signal from your browser.
    </p>
    <br />

    <h2>YOUR RIGHTS</h2>
    <p>
      If you are a European resident, you have the right to access personal
      information we hold about you and to ask that your personal information be
      corrected, updated, or deleted. If you would like to exercise this right,
      please contact us through the contact information below.
    </p>
    <br />
    <p>
      Additionally, if you are a European resident we note that we are
      processing your information in order to fulfill contracts we might have
      with you (for example if you make an order through the Site), or otherwise
      to pursue our legitimate business interests listed above. Additionally,
      please note that your information will be transferred outside of Europe,
      including to Canada and the United States.
    </p>
    <br />

    <h2>DATA RETENTION</h2>
    <p>
      When you place an order through the Site, we will maintain your Order
      Information for our records unless and until you ask us to delete this
      information.
    </p>
    <br />

    <h2>CHANGES</h2>
    <p>
      We may update this privacy policy from time to time in order to reflect,
      for example, changes to our practices or for other operational, legal or
      regulatory reasons.
    </p>
    <br />

    <h2>CONTACT US</h2>
    <p>
      For more information about our privacy practices, if you have questions,
      or if you would like to make a complaint, please contact us by e-mail at
      <strong>{{ clientDetails.clientEmail }}</strong> or by mail using the
      details provided below:
    </p>
    <br />
    <p>
      <strong
        >{{ clientDetails.clientAddress }},
        {{ clientDetails.clientPostalCode }},
        {{ clientDetails.clientCountry }}</strong
      >
    </p>
    <!-- <table class="table">
      <thead>
        <th>Ime piškotka</th>
        <th>Namen piškotka</th>
        <th>Čas trajanja</th>
      </thead>
      <tbody>
        <tr>
          <td>FR</td>
          <td>Facebook piškotek</td>
          <td>Trajanje: do 6 mesecev</td>
        </tr>
      </tbody>
    </table> -->
    <p>
      Version: 1.0 <br />
      Last updated: 29. 5. 2020
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientDetails: null,
    }
  },
  mounted() {
    this.clientDetails = JSON.parse(localStorage.getItem('productData'))
  },
}
</script>

<style scoped>
h1 {
  font-size: 3em;
  line-height: 1.5em;
  margin: 1em;
}
h2 {
  font-size: 2.4em;
  font-weight: 600;
  line-height: 1em;
  margin: 0.5em;
}
h3 {
  font-size: 1.7em;
  line-height: 0.8em;
  margin: 0.4em;
}
h4 {
  font-size: 1.4em;
  line-height: 0.6em;
  margin-top: 1.5em;
}
p {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: justify;
  margin-left: 10em;
  margin-right: 10em;
  word-wrap: break-word;
}
li {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: left;
  margin-left: 20em;
  margin-right: 10em;
  list-style-type: square;
}

th {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: left;
}
td {
  font-size: 0.6em;
  line-height: 1.5em;
  text-align: left;
}
table {
  margin-left: 15em;
}
.link {
  color: var(--bg) !important;
}

.link:active {
  color: var(--primary) !important;
  text-decoration: none;
}

@media screen and (max-width: 680px) {
  .privacy {
    margin: 0;
  }
  h1 {
    font-size: 2.1em;
    line-height: 1em;
    margin: 1em;
  }
  h2 {
    font-size: 1.7em;
    font-weight: 600;
    line-height: 1.2em;
    margin: 0.4em;
  }
  h3 {
    font-size: 1.6em;
    line-height: 1.2em;
    margin: 0.4em;
  }
  h4 {
    font-size: 1.4em;
    line-height: 1em;
    margin-top: 1.5em;
  }
  p {
    font-size: 1em;
    line-height: 1.5em;
    text-align: justify;
    margin: 20px;
    word-wrap: break-word;
  }
  li {
    font-size: 1em;
    line-height: 1.5em;
    text-align: left;
    margin-left: 3em;
    margin-right: 1em;
    list-style-type: square;
  }

  th {
    font-size: 1em;
    line-height: 1em;
    text-align: left;
    padding-bottom: 1.5em;
  }
  td {
    font-size: 0.65em;
    line-height: 1.6em;
    text-align: left;
    padding-bottom: 1.5em;
  }
  table {
    margin: 1em;
  }
}
</style>
